@if (author(); as author) { @if (buildImageSrcForAuthor() | async | dotCmsCodecEncode; as imageSrc) {
<div class="d-flex author-container">
  @if (!isCommentAuthor() || isCommentAuthor()) {
  <div class="post-author-image">
    <img
      [src]="imageSrc"
      [alt]="author.profilePhoto?.title || author.firstName + ' ' + author.lastName"
      [title]="(author.firstName || '') + ' ' + (author.lastName || '')"
    />
  </div>
  }
  <div class="post-author-name">
    @if (!isBlog()) {
    <h3>{{ author?.firstName }} {{ author?.lastName }}</h3>
    }
  </div>
</div>
} }
